import { Injectable } from "@angular/core";
import * as fromCaries from "./conditions/caries/index";
import * as fromPerio from "./conditions/perio/index";
import * as fromEndo from "./conditions/endodontics/index";
import * as fromMissing from "./conditions/missing/index";
import * as fromRestorative from "./conditions/restorative/index";
import * as fromProstho from "./conditions/prostho/index";
import * as fromOrtho from "./conditions/ortho/index";
import * as fromOther from "./conditions/other/index";

@Injectable()
export class DiagnosisConditionsService {
  conditions;

  constructor() {
    // register the conditions
    this.conditions = [
      ...fromCaries.conditions,
      ...fromPerio.conditions,
      ...fromEndo.conditions,
      ...fromMissing.conditions,
      ...fromRestorative.conditions,
      ...fromProstho.conditions,
      ...fromOrtho.conditions,
      ...fromOther.conditions,
    ];
  }

  getClassForCondition(conditionName: string) {
    return this.conditions.filter((condition) =>
      condition.supports(conditionName),
    )[0];
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/diagnosis/diagnosis-conditions.service.ts